<template>
  <span class="position-relative">
    <span
      v-if="hasEventCapturing"
      :class="iconClass"
      class="icon-hover"
      @click="handleClick"
    >
      <mdicon :name="icon" size="24" />
    </span>
    <span
      v-else
      :class="iconClass"
      class="icon-hover"
      @click.stop="handleClick"
    >
      <mdicon :name="icon" size="24" />
    </span>
    <MenuPopup
      :show="showMenu"
      :items="items"
      :permissions="permissions"
      :rowItem="rowItem"
      :class="menuClass"
      @close="handleClose"
    >
      <template #bottom-area>
        <div><slot name="bottom-area"></slot></div>
      </template>
    </MenuPopup>
  </span>
</template>

<script>
import MenuPopup from "./MenuPopup.vue";
import { checkScreenDevice } from "@/shared/utils";
import { toRefs } from "vue";

export default {
  components: { MenuPopup },
  props: {
    showMenu: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "dots-vertical",
    },
    iconClass: {
      type: String,
      default: "",
    },
    menuClass: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    rowItem: {
      type: [Object, Number, String],
      default: null,
    },
    hasEventCapturing: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { rowItem } = toRefs(props);

    const handleClick = () => emit("click", rowItem.value);
    const handleClose = () => emit("close");

    // return data to be used in template
    return {
      rowItem,
      checkScreenDevice,
      handleClick,
      handleClose,
    };
  },
};
</script>
